module.exports = __webpack_public_path__ + "static/media/pica-pau-chorao_thumb.c84e4668.jpg";